import { __awaiter, __generator } from "tslib";
import { version } from '../../constants';
import { getHashOrNull } from '../../utils';
import { logger } from '../../../logger';
import { eventIsTrusted } from '../../utils';
/**@description Trigger `identify()` and `track()` if a Hubspot form has an email field.
 * @param data Object that includes the `type`, `eventName`, `id` of the form & `data` with the input field name and values.
 * @param origin Read-only property of the MessageEvent interface is a USVString representing the origin of the message emitter.
 * @param isTrusted Read-only property of the Event interface is a Boolean that is true when the event was generated by a user action.
 * @param destinations The analytics destinations the data is going to be sent to.
 * @param shouldHash Boolean value that controls if a `sha1 digest` of the email is going to be used as an `id`
 * @param scriptId The `id` of the script which will be included in `track()`
 */
export var handleMessage = function (analytics, event, identifyOptions) {
    var _a = event.data, id = _a.id, data = _a.data;
    var options = identifyOptions.hubspot;
    var form = document.getElementById(id);
    if (form && form.hasAttribute('dd-html')) {
        return;
    }
    data.forEach(function (_a) {
        var fieldName = _a.name, value = _a.value;
        return __awaiter(void 0, void 0, void 0, function () {
            var userId, eventName;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (fieldName !== 'email') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getHashOrNull(identifyOptions.shouldHash || false, value)];
                    case 1:
                        userId = _b.sent();
                        return [4 /*yield*/, analytics.identify(userId, { email: value })];
                    case 2:
                        _b.sent();
                        logger.debug("HubspotPlugin: Identified user with email '".concat(value, "'"));
                        eventName = options.eventName || 'form-hubspot-submit';
                        return [4 /*yield*/, analytics.track(eventName, {
                                hubspotFormId: id,
                                version: version,
                            })];
                    case 3:
                        _b.sent();
                        logger.debug("HubspotPlugin: Tracking submit with hubspotFormId '".concat(id, "'"));
                        return [2 /*return*/];
                }
            });
        });
    });
};
export default (function (analytics, options) {
    window.addEventListener('message', function (event) {
        var _a = event.data, type = _a.type, eventName = _a.eventName;
        /**
         * Callback that executes after form is validated, just before the data is actually sent.
         *
         * In an essence, this event will fire right after the Hubspot has validated that the email is valid and not already registered
         * in the system. The next event fired will be 'onFormSubmitted'.
         */
        if (eventIsTrusted(event) &&
            type === 'hsFormCallback' &&
            eventName === 'onFormSubmit') {
            handleMessage(analytics, event, options);
        }
    });
});
//# sourceMappingURL=index.js.map